import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import Model from '../../../model';
import { Navigate } from 'react-router-dom';
import Loader from 'components/Loader';
import Page from '../Page';

const getRedirectUrl = (paymentType) => {
    const isGoodBought = paymentType === 'buy';
    const isConsultationBought = paymentType === 'order' || paymentType === 'ticket';
    const isDigitalBought = paymentType === 'audio' || paymentType === 'course' || paymentType === 'webinar';
    const isCertBought = paymentType === 'cert';

    const { isAuthenticated } = Model.user;

    if (!isAuthenticated) { return '/'; }
    if (isGoodBought || isDigitalBought) { return '/items'; }
    if (isConsultationBought) { return '/orders'; }
    if (isCertBought) { return '/profile'; }
    console.error(`unrecognized payment type ${ paymentType }`);
    return '/';
};

const FinishPayment = () => {
    const { token, payment_type: paymentType } = useParams();

    const checkUrl = `/finish_payment/${ paymentType }/${ token }`;
    const redirectUrl = getRedirectUrl(paymentType);

    const { openOrderForm } = Model.modal;
    const { setSubmitSuccess } = Model.orderForm;

    const [ renderBody, setRenderBody ] = useState(
        <Page showHeader={false}>
            <Loader styles={{height: '100%'}}/>
        </Page>
    );

    useEffect(() => {
        fetch(checkUrl)
            .then((promise) => {
                return promise.json();
            })
            .then((response) => {
                setRenderBody(<Navigate to={ redirectUrl } state={ { response } } replace={ true }/>)
            }).catch((err) => {
                console.log(err);
                setRenderBody(<Navigate to={ '/' } replace={ true }/>)
            })
    }, [ token ]);

    return renderBody;
}

export default FinishPayment;
